import { IAppCallbackProps } from 'components/appCallback/AppCallback.types';
import BlikPending from 'components/blikPending/BlikPending';
import CancelScreen from 'components/cancelScreen/CancelScreen';
import { IErrorProps } from 'components/errorViewSelector/ErrorViewSelector';
import PaymentExpiredScreen from 'components/errorViewSelector/paymentExpiredScreen/PaymentExpiredScreen';
import RealisedScreen from 'components/realisedScreen/RealisedScreen';
import { APP_STATUS, AppState, ERROR_SCREEN_TYPES } from 'config/config';
import { PaymentCategoryType } from 'consts';
import withContext from 'hoc/withContext';
import withLicenseNoteContext from 'hoc/withLicenseNoteContext';
import withLocaleContext from 'hoc/withLocaleContext';
import withTextContext from 'hoc/withTextContext';
import queryString from 'query-string';
import React, { Component } from 'react';
import { getPaymentDetails, getPaymentStatus } from 'services/Api';
import License from 'types/License';
import { IPayment } from 'types/Payment';

import { IAppState } from 'types/ApplicationState';
import AbandonedScreen from '../abandonedScreen/AbandonedScreen';
import InProgressScreen from '../inProgressScreen/InProgressScreen';
import StartedStatusScreen from '../startedStatusScreen/StartedStatusScreen';
import withAppStateContext from '../../hoc/withAppStateContext';

interface IState {
  status: string;
  isLoading: boolean;
  paymentDetails: Partial<IPayment>;
}

class AppStatus extends Component<
  IAppCallbackProps &
    Partial<ITextContext> &
    Partial<IContext> &
    Partial<ILicenseNoteContext> &
    Partial<ILocaleContext> &
    Partial<IAppState>,
  IState
> {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      paymentDetails: {},
      status: '',
    };
  }

  async componentDidMount() {
    try {
      const {
        match: {
          params: { paymentId },
        },
        setPaymentDetails,
        setPaymentStatusText,
        setLicense,
        setLocaleFromPaymentRequest,
        setAppState,
      } = this.props;
      const { status } = await getPaymentStatus(paymentId);
      const paymentDetails: IPayment = await getPaymentDetails(paymentId);
      const paymentStatus = paymentDetails.status === 'EXPIRED' ? paymentDetails.status : status;
      setAppState?.(AppState.STATUS);
      setPaymentDetails(paymentDetails, paymentId);
      if (setLicense) {
        if (paymentDetails.license) {
          setLicense(paymentDetails.license);
        } else {
          setLicense(License.MBANK);
        }
      }

      if (setPaymentStatusText) {
        setPaymentStatusText('transactionNumber');
      }

      if (setLocaleFromPaymentRequest) {
        setLocaleFromPaymentRequest(paymentDetails.locale);
      }

      this.setState({ status: paymentStatus, isLoading: false, paymentDetails });
    } catch (error) {
      this.setState(() => {
        const castedError: IErrorProps = error as IErrorProps;
        castedError.screenType = castedError.screenType || ERROR_SCREEN_TYPES.PAYMENT;
        throw castedError;
      });
    }
  }

  statusToView = () => {
    const {
      match: {
        params: { paymentId },
      },
    } = this.props;
    const { status } = this.state;
    const selectedPaymentMethodType = String(queryString.parse(window.location.search).selectedPaymentMethodType);
    const { paymentDetails } = this.state;

    if (selectedPaymentMethodType === PaymentCategoryType.BLIK && status === APP_STATUS.PENDING) {
      return <BlikPending />;
    }

    const statuses = {
      [APP_STATUS.ABANDONED]: <AbandonedScreen paymentId={paymentId} />,
      [APP_STATUS.SUCCESS]: <RealisedScreen />,
      [APP_STATUS.NEW]: <StartedStatusScreen />,
      [APP_STATUS.PENDING]: <InProgressScreen paymentDetails={paymentDetails} paymentId={paymentId} />,
      [APP_STATUS.FAILURE]: (
        <CancelScreen paymentId={paymentId} recoveryEnabled={paymentDetails.errorRejectRecoveryEnabled} />
      ),
      [APP_STATUS.ERROR]: (
        <CancelScreen paymentId={paymentId} recoveryEnabled={paymentDetails.errorRejectRecoveryEnabled} />
      ),
      [APP_STATUS.EXPIRED]: <PaymentExpiredScreen />,
    };

    return statuses[status];
  };

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return false;
    }
    return this.statusToView();
  }
}

export default withLicenseNoteContext(withContext(withTextContext(withLocaleContext(withAppStateContext(AppStatus)))));
